import { ApolloClient, from, HttpLink, InMemoryCache } from '@apollo/client'
import { previewReadOnlyLink } from './previewReadOnlyLink'
import { createGraphqlErrorLink } from './graphqlErrorLink'
import { offsetMergeFieldPolicy } from './offsetMergeFieldPolicy'
import { KeySpecifier } from '@apollo/client/cache/inmemory/policies'

const httpLink = new HttpLink({
  uri: process.env.EXPO_PUBLIC_GRAPHQL_URL,
})

const createFieldPolicy = (keyArgs: KeySpecifier) => ({
  keyArgs,
  merge(existing = { nodes: [] }, incoming: { nodes: [] }) {
    if (!incoming) return { ...existing, nodes: existing.nodes }
    return {
      ...incoming,
      nodes: [...existing.nodes, ...incoming.nodes],
    }
  },
})

export const apolloClient = new ApolloClient({
  cache: new InMemoryCache({
    typePolicies: {
      Course: {
        fields: {
          courseModules: createFieldPolicy(['id']),
        },
      },
      ProgressCard: {
        fields: {
          // A área do aluno consome a lista INTEIRA (quais aulas estão
          // concluídas), então as páginas precisam se acumular no cache — senão o
          // refetch de foco reescreve o campo com a primeira página e as aulas de
          // fora dela voltam a aparecer como não concluídas.
          lessonsProgresses: offsetMergeFieldPolicy(['ordenation']),
        },
      },
    },
  }),
  link: from([previewReadOnlyLink, createGraphqlErrorLink(), httpLink]),
})
